import React, { forwardRef } from 'react';
import { Input } from '@mui/joy';
import { IMaskInput } from 'react-imask';

/**
 * MaskedInput - компонент ввода с маской, стилизованный под MUI Joy
 * 
 * @param {Object} props
 * @param {string} props.mask - Маска для ввода (например: "+7 (000) 000-00-00")
 * @param {Object} props.definitions - Кастомные определения символов маски
 * @param {boolean} props.lazy - Показывать маску только при фокусе
 * @param {boolean} props.overwrite - Режим перезаписи при вводе
 * @param {string} props.placeholderChar - Символ-заполнитель
 * @param {any} props.value - Контролируемое значение
 * @param {function} props.onChange - Обработчик изменения значения
 * @param {function} props.onAccept - Обработчик принятия значения
 * @param {Object} props.inputProps - Дополнительные пропсы для IMask
 * @param {ref} ref - React ref
 * @param {Object} ...rest - Все остальные пропсы передаются в Joy Input
 */
const MaskedInput = forwardRef((props, ref) => {
  const {
    mask,
    definitions,
    lazy = false,
    overwrite = 'shift',
    placeholderChar = '_',
    value,
    onChange,
    onAccept,
    inputProps = {},
    ...inputJoyProps
  } = props;

  // Объединяем обработчики
  const handleAccept = (val, maskRef) => {
    if (onAccept) {
      onAccept(val, maskRef);
    }
    // Создаем синтетическое событие для onChange
    if (onChange) {
      const event = {
        target: {
          name: props.name,
          value: val,
        },
      };
      onChange(event);
    }
  };

  return (
    <Input
      {...inputJoyProps}
      value={value}
      slotProps={{
        input: {
          color: "#572AC3",
          component: IMaskInput,
          mask: mask,
          inputRef: ref,
          definitions: definitions || {
            '#': /[0-9]/,
            '0': /[0-9]/,
            '9': /[0-9]/,
            'A': /[A-Z]/,
            'a': /[a-z]/,
            '!': /[A-Za-z]/,
            '*': /./,
          },
          lazy: lazy,
          overwrite: overwrite,
          placeholderChar: placeholderChar,
          onAccept: handleAccept,
          ...inputProps,
        },
      }}
    />
  );
});

MaskedInput.displayName = 'MaskedInput';

export default MaskedInput;